import SectionTitle from "@/components/base/SectionTitle";
import PostCard from "@/components/base/PostCard";
import { posts } from "@/mocks/community";

export default function FeaturedPosts() {
  const featured = [...posts].sort((a, b) => b.commentCount - a.commentCount).slice(0, 6);

  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-container px-4 md:px-6">
        <SectionTitle
          eyebrow="高互动"
          title="高互动爆料帖一网打尽"
          desc="按回复与围观数据筛选出的高互动内容，讨论正在发生，点进去就能接上话。"
          moreTo="/topics"
          moreLabel="查看更多帖"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
}